window.onload = function() {

  let modalTrigger = document.getElementById('menu-modal-trigger');
  let modalMenu = document.getElementById('footer-menu-modal');
  let body = document.body;
  let modalSubMenu = document.querySelectorAll('.modal-menu__submenu');
  let menuCard = document.querySelectorAll('.modal-menu__card');
  let menuModalBack = document.getElementById('modal-menu__back');
  let menuModalClose = document.getElementById('modal-menu__close');

  // Open modal
  modalTrigger.addEventListener('click', function(){
    modalMenu.style.display = "block";
    body.classList.add('modal-open');
  })

  // Close modal
  menuModalClose.addEventListener('click', function(){
    modalMenu.style.display = "none";
    body.classList.remove('modal-open');
    
    modalSubMenu.forEach(i => {
      i.style.display = "none";
    })
    menuCard.forEach(i => {
      i.style.display = "flex";
    })
    menuModalBack.style.display = "none";
  })

  // open submenu
  menuCard.forEach((item, index, arr) => {
    item.addEventListener('click', function(e){
      if (index !== 0) {
        arr.forEach(i => i.style.display = "none");

        let subMenu = document.getElementById(this.getAttribute('data-submenu'));
        subMenu.style.display = "block";

        menuModalBack.style.display = "block";
      }
    })
  })

  // back button 
  menuModalBack.addEventListener('click', function(){
    modalSubMenu.forEach(i => {
      i.style.display = "none";
    })
    menuCard.forEach(i => {
      i.style.display = "flex";
    })
    this.style.display = "none";
  })

}